export function PagePublicAndPrivate () {
  return (
    <div>
      <h1>PagePublicAndPrivate</h1>
    </div>
  )
}
